import { render, staticRenderFns } from "./SwipingExplanationView.vue?vue&type=template&id=44d36dd3&scoped=true&"
import script from "./SwipingExplanationView.vue?vue&type=script&lang=js&"
export * from "./SwipingExplanationView.vue?vue&type=script&lang=js&"
import style0 from "./SwipingExplanationView.vue?vue&type=style&index=0&id=44d36dd3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d36dd3",
  null
  
)

export default component.exports